import styled from 'styled-components';
import { Loader } from '@components';
import Button from '@components/ButtonTs';
import Input from '@components/Input';
import Select from '@components/Select';

const Panel = styled.section`background:#fff;border:1px solid #dfe2e6;border-radius:7px;box-shadow:0 1px 4px rgba(24,35,48,.05);`;
export const Page = styled.main`align-self:stretch;background:#eef0f2;display:grid;gap:12px;grid-template-rows:auto minmax(0,1fr);height:100%;min-height:650px;padding:12px;width:100%;`;
export const Topbar = styled(Panel)`padding:12px 16px;`;
export const Title = styled.h1`font-size:21px;line-height:26px;margin:0;`;
export const Muted = styled.div`color:#919499;font-size:12px;line-height:17px;`;
export const Content = styled.div`display:grid;gap:12px;grid-template-columns:345px minmax(650px,1fr);min-height:0;`;
export const LeadList = styled(Panel)`display:grid;grid-template-rows:auto minmax(0,1fr);min-height:0;overflow:hidden;`;
export const Filters = styled.div`display:grid;gap:8px;padding:12px;`;
export const SearchInput = styled(Input)`border-color:#d9dce1;font-size:13px;height:36px;padding:0 10px;width:100%;`;
export const StatusSelect = styled(Select)`border:1px solid #d9dce1;width:100%;`;
export const CheckboxLabel = styled.label`align-items:center;color:#687078;display:flex;font-size:12px;gap:7px;`;
export const ListBody = styled.div`border-top:1px solid #e1e3e6;min-height:0;overflow:hidden;position:relative;`;
export const ListError = styled.div`background:#fff1f0;color:#b42318;font-size:12px;padding:10px 12px;position:absolute;top:0;width:100%;z-index:2;`;
export const NextPageLoader = styled.div`align-items:center;display:flex;justify-content:center;`;
export const LeadRow = styled.button<{ $active:boolean }>`align-items:center;background:${({$active})=>$active?'#f1f7ff':'#fff'};border:0;border-bottom:1px solid #eceef0;border-left:3px solid ${({$active})=>$active?'#007aff':'transparent'};cursor:pointer;display:flex;gap:9px;padding:10px 12px;text-align:left;width:100%;`;
export const RowMain = styled.div`display:grid;gap:2px;min-width:0;flex:1;strong,span,small{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}strong{font-size:13px;}span,small{color:#7d8288;font-size:11px;}`;
export const RowMeta = styled.div`align-items:flex-end;display:flex;flex-direction:column;gap:5px;white-space:nowrap;small{color:#919499;font-size:10px;}`;
export const StatusBadge = styled.span<{ $status:string }>`background:${({$status})=>$status==='new'?'#eef6ff':$status==='in_progress'?'#fff6e5':'#eef1f3'};border-radius:11px;color:${({$status})=>$status==='new'?'#1671d9':$status==='in_progress'?'#a15c00':'#667078'};font-size:10px;padding:3px 7px;`;
export const EmptyList = styled.div`display:grid;gap:5px;justify-items:center;padding:44px 20px;text-align:center;`;
export const ListLoader = styled(Loader)`align-items:center;display:flex;justify-content:center;min-height:220px;width:100%;`;
export const DetailsPanel = styled(Panel)`
  background: #f0f1f2;
  min-width: 0;
  overflow: hidden;
`;
export const DetailsLoader = styled(Loader)`align-items:center;display:flex;height:100%;justify-content:center;min-height:420px;width:100%;`;
export const EmptyDetails = styled.div`align-content:center;display:grid;gap:7px;height:100%;justify-items:center;padding:30px;text-align:center;`;
export const Detail = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
`;
export const DetailsHeader = styled.header`
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e1e3e6;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding: 15px 18px;

  h2 {
    font-size: 19px;
    margin: 3px 0 2px;
  }
`;
export const HeaderMeta = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 7px;
  white-space: nowrap;

  small {
    color: #919499;
    font-size: 11px;
  }
`;
export const ContactLine = styled.div`
  color: #007aff;
  font-size: 12px;
`;
export const DetailScroll = styled.div`
  display: grid;
  align-content: start;
  gap: 12px;
  min-height: 0;
  overflow: auto;
  padding: 12px;
`;
// Колонки как на странице заказа: основная и «Связанные сущности» той же ширины.
export const DetailColumns = styled.div`
  align-items: start;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(430px, 1.3fr) minmax(285px, 0.7fr);
`;
export const DetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;
export const RelationsHint = styled.div`
  color: #919499;
  font-size: 12px;
  line-height: 17px;
  padding: 14px;
`;
export const RelationsLoader = styled(Loader)`align-items:center;display:flex;justify-content:center;padding:14px;width:100%;`;
export const Block = styled.section`
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;
export const BlockTitle = styled.h3`
  border-bottom: 1px solid #eceef0;
  font-size: 15px;
  margin: 0;
  padding: 13px 14px;
`;
export const BlockContent = styled.div`
  padding: 14px;
`;
export const DetailGrid = styled.div`display:grid;gap:14px 24px;grid-template-columns:repeat(2,minmax(0,1fr));`;
// Подпись и значение — прямые дети поля: вложенные в значение элементы (например, HotelName) не перекрашиваются в подпись.
export const DetailItem = styled.div`display:grid;gap:3px;>span{color:#919499;font-size:11px;}>div{font-size:13px;overflow-wrap:anywhere;}`;
// Комментарий — поле на всю ширину сетки, с переносами строк, как их оставил клиент.
export const CommentItem = styled(DetailItem)`grid-column:1/-1;>div{line-height:19px;white-space:pre-wrap;}`;
export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;
// У primary-кнопки нет своей рамки — без этого браузер рисует стандартную.
export const PrimaryButton = styled(Button)`border: none;`;
// Выбор статуса выглядит как бейдж статуса; список открывается поверх шапки, не раздвигая её.
export const LeadStatusSelect = styled(Select)`
  background: transparent;
  height: auto;
  line-height: normal;
  position: relative;
  width: auto;

  > button {
    gap: 6px;
    height: auto;
    padding: 0;
  }

  > button svg path {
    fill: #919499;
  }

  ul {
    margin-top: 8px;
    min-width: 150px;
    position: absolute;
    right: 0;
    top: 100%;
  }

  /* Без line-height пункта списка (31px), иначе бейдж-флекс-элемент растягивается по высоте строки. */
  li {
    align-items: center;
    display: flex;
    line-height: normal;
  }

  li > button {
    align-items: center;
    display: flex;
  }

  li[data-selected='true'] {
    background-color: #f2f7ff;
    color: inherit;
  }
`;
export const CloseReasonSelect = styled(Select)`
  border: 1px solid #d9dce1;
  font-size: 12px;
  height: 32px;
  line-height: 30px;
  width: 190px;
`;
